import React from "react";
import {LoginCallback, useOktaAuth} from "@okta/okta-react";

const OktaLoginCallback = () => {
	const { oktaAuth } = useOktaAuth();

	return (
		<LoginCallback
			errorComponent={() => {
				const id = setTimeout(() => {
					localStorage.clear();
					window.location = '/'
				}, 2000);

				oktaAuth.signOut().then(() => {
					clearTimeout(id);
				});

				return null;
			}}
		/>
	);
};

export default OktaLoginCallback;
